import { render, staticRenderFns } from "./ProductDialogForm.vue?vue&type=template&id=3f60e97b&"
import script from "./ProductDialogForm.vue?vue&type=script&lang=js&"
export * from "./ProductDialogForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports